import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtKanaHiraganaBehavior } from "./PtKanaHiraganaBehavior";

/** HIS項目患者ふりがな・姓を生成する */
export class PtKanaHiraganaSeiBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_KANA_HIRAGANA_SEI";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtKanaHiraganaSeiBehavior.Key).map(x => x.value);
    const behavior = new PtKanaHiraganaBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const sei = values.map(x => StringUtility.getTextBeforeSpace(x));
    const data = itemValues.length > 0 ? itemValues : sei;
    return new HisInformationTextValue(PtKanaHiraganaSeiBehavior.Key, data);
  }
}
